// extracted by mini-css-extract-plugin
export default {"person-wrapper":"RenderedPerson_person-wrapper__GWtbt","active-user":"RenderedPerson_active-user__Co9v5","active_span":"RenderedPerson_active_span__RXzTy"};